import "./src/polyfill.js";
import "./src/utils/numberKeyboardEnforcer.js";
import React from "react";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { ThemeProvider } from "./src/context/ThemeContext";
import "./src/style.css";
import { GlobalPlatformProvider } from "./src/context/PlatformContexts";
import { scanAndEnforceAllInputs } from "./src/utils/numberKeyboardEnforcer.js";
import { PageLocationContext } from "./src/components/layout";

const cache = createCache({ key: "css" });

// Guard against third-party Tawk.to language loading failures
// ("t.$_Tawk.i18next is not a function") triggered by adblockers, tracking protection, or network drops
if (typeof window !== "undefined") {
  window.$_Tawk = window.$_Tawk || {};
  if (typeof window.$_Tawk.i18next !== "function") {
    const fallbackI18n = function (key) {
      if (typeof key === "string") {
        const parts = key.split(".");
        return parts[parts.length - 1] || key;
      }
      return key || "";
    };

    let _i18next = fallbackI18n;
    try {
      Object.defineProperty(window.$_Tawk, "i18next", {
        get: () => _i18next,
        set: (val) => {
          if (typeof val === "function") {
            _i18next = val;
          }
        },
        configurable: true,
        enumerable: true,
      });
    } catch {
      window.$_Tawk.i18next = fallbackI18n;
    }
  }
}

export const wrapRootElement = ({ element }) => {
  return (
    <CacheProvider value={cache}>
      <GlobalPlatformProvider>
        <ThemeProvider>{element}</ThemeProvider>
      </GlobalPlatformProvider>
    </CacheProvider>
  );
};

export const wrapPageElement = ({ element, props }) => {
  return (
    <PageLocationContext.Provider value={props?.location?.pathname || ""}>
      {element}
    </PageLocationContext.Provider>
  );
};

export const onRouteUpdate = () => {
  scanAndEnforceAllInputs();
};

